import React from "react";

export const MensajeOk = (props) => {
    return (
        <div className={"message-box"} id={"register-ok"}>
            <h3 dangerouslySetInnerHTML={{ __html: props.mensajeOk}}>
            </h3>
        </div>
    )
}